// extracted by mini-css-extract-plugin
module.exports = {"container":"authorization_container__164-K","iconsContainer":"authorization_iconsContainer__3E2YE","selectflex":"authorization_selectflex__2DtEs"};